module.exports = __webpack_public_path__ + "static/the-dentists-at-gateway-crossing-f75e16b289a9a21aedb8297947fc0b4b.jpg";